import React from 'react'
import { Grid, TextField } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import Button from 'components/ButtonMaterial'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import pick from 'lodash.pick'
import isempty from 'lodash.isempty'
import { showFlashMessage, showFlashMessageOnUnexpectedError, contactUs } from 'actions'
import { EMAIL_REGEX, PHONE_REGEX } from '../constants'
import Footer from '../components/Footer'
import MenuBar from '../components/header/MenuBar'
import { trackPage } from 'utils'
import FlashMessage from 'components/FlashMessage'
import Loader from '../components/Loader'

const styles = theme => ({
  grid: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: '0',
  },
  gridPadding: {
    paddingLeft: '2%',
  },
  profileImage: {
    width: '100%',
    borderRadius: '50%',
  },
  form: {
    width: '100%',
    '& input': {
      borderRadius: '4px',
      backgroundColor: 'rgba(0, 0, 0, 0.06)',
      padding: '12px 10px',
    },
    '& textarea': {
      borderRadius: '4px',
      height: '200px !important',
      backgroundColor: 'rgba(0, 0, 0, 0.06)',
      padding: '12px 10px',
      width: 'calc(100% - 20px)',
      [theme.breakpoints.down('xs')]: {
        height: '100px !important',
      },
    },
  },
  textFieldFirstName: {
    marginTop: '32px',
    marginBottom: '0',
    width: '100%',
    '& > label': {
      textTransform: 'uppercase',
      color: '#a9aeba',
    },
  },
  textFieldSecondName: {
    marginTop: '32px',
    marginBottom: '0',
    width: '100%',
    '& > label': {
      textTransform: 'uppercase',
      color: '#a9aeba',
    },
  },
  textFieldFullWidth: {
    marginTop: '32px',
    marginBottom: '0',
    width: '100%',
    '& > label': {
      textTransform: 'uppercase',
      color: '#a9aeba',
    },
  },
  cssLabel: {
    '&$cssFocused': {
      color: 'black',
    },
  },
  cssLabelError: {
    '&$cssFocused': {
      color: 'red',
    },
  },

  cssFocused: {},
  cssUnderline: {
    padding: '0',
    '&:hover': {
      '&:before': {
        borderBottomColor: 'transparent !important',
      },
    },
    '&:before': {
      borderBottomColor: 'transparent',
    },
    '&:after': {
      borderBottomColor: 'transparent',
    },
  },
  updateBtn: {
    width: '240px',
    fontSize: '18px',
    fontWeight: '500',
    marginTop: '39px',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
    '&:hover': {
      backgroundColor: '#00bcb5 !important',
    },
  },
  changeImageBtn: {
    width: '40%',
    [theme.breakpoints.down('sm')]: {
      width: '26%',
    },
    [theme.breakpoints.down('xs')]: {
      width: '41%',
    },
    height: '33px',
  },
  //the idea is to hide the input, but to have it in the DOM so we can use it as ref
  fileInput: {
    fontSize: '100px',
    opacity: '0',
    overflow: 'hidden',
    position: 'absolute',
    top: '0',
    left: '0',
    width: '0.1px',
    height: '0.1px',
  },
  contactGrid: {
    flex: '0 0 100%',
  },
  contactContainer: {
    width: '900px',
    margin: '0 auto',
    [theme.breakpoints.down('900')]: {
      width: '100%',
    },
  },
  contactTopgrid: {
    [theme.breakpoints.down('900')]: {
      padding: '0 16px',
    },
  },
  contactTitle: {
    fontSize: '26px',
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: '-0.36px',
    color: '#00bcb5',
    padding: '58px 0',
    margin: '0',
    textTransform: 'uppercase',
    [theme.breakpoints.down('900')]: {
      padding: '30px 0',
    },
    [theme.breakpoints.down('767')]: {
      fontSize: '20px',
      padding: '20px 0 10px',
    },
  },
  contactHead: {
    fontSize: '20px',
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: '-0.28px',
    color: '#2d3447',
    padding: '0 0 10px',
    margin: '0',
    [theme.breakpoints.down('767')]: {
      fontSize: '18px',
    },
  },
  contactPara: {
    fontSize: '16px',
    lineHeight: '1.39',
    color: '#000',
    margin: '0',
    [theme.breakpoints.down('767')]: {
      fontSize: '15px',
    },
  },
  contactPageForm: {
    margin: '58px 0',
    borderRadius: '4px',
    padding: '40px 56px 40px 26px',
    background: '#fff',
    boxShadow: '0 7px 23px 0 rgba(0, 0, 0, 0.04)',
    [theme.breakpoints.down('900')]: {
      margin: '30px 0',
      padding: '0 16px 30px 0',
    },
    [theme.breakpoints.down('767')]: {
      margin: '20px 0 30px',
      paddingLeft: '16px',
    },
  },
  contactLeftbox: {
    width: '50%',
    paddingLeft: '30px',
    [theme.breakpoints.down('900')]: {
      paddingLeft: '16px',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      paddingLeft: '0',
    },
  },
})

const userFields = ['name', 'email', 'phone', 'message']
class ContactUs extends React.Component {
  constructor(props) {
    super(props)
    this.state = userFields.reduce((output, field) => ({ ...output, [field]: '' }), { errors: {}, showSettings: false, loading: false })

    this.fileInput = null

    this.setFileInputRef = element => {
      this.fileInput = element
    }
  }

  componentDidMount() {
    trackPage(window.location.pathname)
    window.scrollTo(0, 0)
  }

  onFormFieldChange = event => {
    const target = event.target
    const name = target.id
    const value = target.value

    this.setState(state => ({
      [name]: value,
      errors: { ...state.errors, [name]: this.validateField(name, value) },
    }))
  }

  validateField = (name, value) => {
    if (value === '') {
      return 'is missing'
    } else if (value === null || value === undefined) {
      return 'is invalid'
    }
    switch (name) {
      case 'name':
      case 'message': {
        if ('' === value.trim()) {
          return 'is invalid'
        }
        break
      }
      case 'email': {
        if (!value.match(EMAIL_REGEX)) {
          return 'is invalid'
        }
        break
      }
      case 'phone': {
        if (!value.match(PHONE_REGEX) || value.length < 9) {
          return 'is invalid'
        }
        break
      }
      default:
        break
    }
  }

  isValid = () => {
    return userFields.reduce((a, f) => a && this.state[f] && !this.state.errors[f], true)
  }

  handleSubmit = async event => {
    event.preventDefault()
    this.loadingState()
    if (this.isValid()) {
      try {
        const dataToBeUpdated = pick(this.state, userFields)

        for (var key in dataToBeUpdated) {
          dataToBeUpdated[key] = dataToBeUpdated[key].trim()
        }

        const response = await this.props.contactUs(dataToBeUpdated)

        if (isempty(response.errors)) {
          this.loadingState()
          this.setState({ email: '', phone: '', message: '', name: '' })
          this.props.showFlashMessage(null, `Your request has been sent successfully!`)
        } else {
          this.loadingState()
          this.props.showFlashMessage(true, response.errors.map(field => `${field[0]} ${field[1].join(', ')}`).join(';'))
        }
      } catch (error) {
        this.loadingState()
        this.props.showFlashMessageOnUnexpectedError(error)
      }
    }
  }

  loadingState = () => {
    this.setState(prevState => ({
      loading: !prevState.loading,
    }))
  }

  render() {
    const { name, message, phone, email, errors, showSettings, loading } = this.state
    const { classes } = this.props

    const labelProps = {
      shrink: true,
      FormLabelClasses: {
        root: classes.cssLabel,
        focused: classes.cssFocused,
        error: classes.cssLabelError,
      },
    }

    return (
      <Grid container>
        <Grid item xs={12}>
          <MenuBar hidePremium={true} showSettings={showSettings} setShowSettings={this.setShowSettings} />
        </Grid>
        <div className={classes.contactGrid}>
          <div className={classes.contactContainer}>
            <Grid item className={classes.contactTopgrid}>
              <h3 className={classes.contactTitle}>Contact us</h3>
              <h5 className={classes.contactHead}>The Perfect Investment Property Is Waiting</h5>
              <p className={classes.contactPara}>
                Fast deals. Fair deals. Smart deals. You’ll find them all waiting for you at DealVestors. Contact us today for more information or to discuss a
                listed investment property.
              </p>
            </Grid>
            <Grid item container className={classes.contactPageForm}>
              <form noValidate autoComplete="off" className={classes.form}>
                <Grid item className={classes.grid}>
                  <div className={classes.contactLeftbox}>
                    <TextField
                      id="name"
                      label="Name"
                      className={classes.textFieldFirstName}
                      value={name}
                      margin="normal"
                      InputLabelProps={labelProps}
                      InputProps={{
                        classes: {
                          underline: classes.cssUnderline,
                        },
                        inputProps: {
                          maxLength: 80,
                        },
                      }}
                      error={errors.name ? true : false}
                      helperText={errors.name}
                      onChange={this.onFormFieldChange}
                    />
                    <TextField
                      id="email"
                      label="EMAIL"
                      value={email}
                      className={classes.textFieldFirstName}
                      margin="normal"
                      fullWidth
                      InputLabelProps={labelProps}
                      InputProps={{
                        classes: {
                          underline: classes.cssUnderline,
                        },
                        inputProps: {
                          maxLength: 80,
                        },
                      }}
                      error={errors.email ? true : false}
                      helperText={errors.email}
                      onChange={this.onFormFieldChange}
                    />
                    <TextField
                      id="phone"
                      label="PHONE"
                      className={classes.textFieldSecondName}
                      value={phone}
                      margin="normal"
                      fullWidth
                      InputLabelProps={labelProps}
                      InputProps={{
                        classes: {
                          underline: classes.cssUnderline,
                        },
                        inputProps: {
                          maxLength: 40,
                        },
                      }}
                      error={errors.phone ? true : false}
                      helperText={errors.phone}
                      onChange={this.onFormFieldChange}
                    />
                  </div>
                  <div className={classes.contactLeftbox}>
                    <TextField
                      id="message"
                      label="Comments"
                      multiline
                      rowsMax="4"
                      value={message}
                      className={classes.textFieldFullWidth}
                      margin="normal"
                      fullWidth
                      InputLabelProps={labelProps}
                      InputProps={{
                        classes: {
                          underline: classes.cssUnderline,
                        },
                      }}
                      error={errors.message ? true : false}
                      helperText={errors.message}
                      onChange={this.onFormFieldChange}
                    />
                  </div>
                </Grid>
                <Grid item align="right">
                  <Button onClick={this.handleSubmit} className={classes.updateBtn} disabled={!this.isValid()}>
                    {loading ? <Loader color="white" /> : 'Send Request'}
                  </Button>
                </Grid>
              </form>
            </Grid>
          </div>
        </div>
        <Footer />
        <FlashMessage />
      </Grid>
    )
  }
}

ContactUs.propTypes = {
  classes: PropTypes.object,
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      showFlashMessage,
      showFlashMessageOnUnexpectedError,
      contactUs,
    },
    dispatch
  )
}

export default withStyles(styles)(
  connect(
    null,
    mapDispatchToProps
  )(ContactUs)
)



// WEBPACK FOOTER //
// ./src/containers/ContactUs.js